import React from 'react'
function Vacinacao({ style, className, width = "55px", height = "57px" }) {
    return (
        <svg
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <polyline points="9 12 11 14 15 9" />
        </svg>
    );
};
export default Vacinacao;
